import React, { useState, useEffect, lazy, Suspense } from "react";
import { Alert, Layout, Row, Spin } from "antd";

import { useDispatch } from "react-redux";
import { appSelector } from "../helpers/appSelector";
import { AppDispatch } from "../helpers/appDispatch";
import { withRouter, useHistory } from "react-router-dom";

import { path } from "../helpers/path";
import { useTranslation } from "react-i18next";

import { clearStates, getFilesRequest } from "../store/bulk-payment";

const FilterMenu = lazy(
  () => import("../components/bulkpayment-pages/FilterMenu")
);
const Files = lazy(
  () => import("../components/bulkpayment-pages/PaymentFiles")
);

const PaymentPages = () => {
  const dispatch: AppDispatch = useDispatch();

  const { files, filesTotal, loadingFiles, error } = appSelector((state) => state.bulkPayment);
  const { Content } = Layout;

  const [fileData, setFileData] = useState(files);

  const { t } = useTranslation();
  const history = useHistory();
  const [processStatus, setProcessStatus] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const getErrorMessage = (error: any) => {
    if (typeof error === "string") return error;
    return error?.detail || error?.message || error?.title || JSON.stringify(error);
  };

  useEffect(() => {
    dispatch(clearStates());
    dispatch(getFilesRequest({ pageSize: 10, skip: 0 }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const data: string = JSON.stringify(files);
    localStorage.setItem("status", data);
  }, [files]);

  const onClickRow = (fileId: number) => {
    history.push(`${path.file}/${fileId}`);
  };

  const onLoadMore = (page: number, pageSize: number) => {
    setCurrentPage(page);
    dispatch(getFilesRequest({ pageSize, skip: page - 1 }));
  };

  const onReset = (form: any) => {
    form.resetFields();
    // setPageData(pages);
  };

  return (
    <div className="padding-box">
      <Content className="site-layout-background site-box">
        <Suspense
          fallback={
            <Row className="suspense-container">
              <div style={{ marginTop: "200px" }}>
                <Spin />
              </div>
            </Row>
          }
        >
          {/* <FilterMenu onReset={onReset} onSearch={onReset} translate={t} /> */}
          <div className="margin-top">
            <Row style={{ position: "relative" }}>
              <h4 className="transaction-chart-text">
                {t("general.paymentPage")}
              </h4>
              <div className="utility-buttons">
                {/* <Button
                  type="primary"
                  className="export-buttons"
                  onClick={() => reloadPages()}
                >
                  {t("general.newPageText")}
                </Button> */}
              </div>
            </Row>
          </div>

          <Files
            files={files}
            onClickRow={onClickRow}
            onLoadMore={onLoadMore}
            loading={loadingFiles}
            translate={t}
            total={filesTotal}
            currentPage={currentPage}
          />
          {error && !loadingFiles ? (
            <Alert
              message={t("general.failedToFetch")}
              description={getErrorMessage(error)}
              type="error"
              showIcon
            />
          ) : null}
        </Suspense>
      </Content>
    </div>
  );
};

export default withRouter(PaymentPages);
